import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// Papéis tipográficos declarados em globals.css (@theme --text-*). Sem registrá-los
// aqui, o tailwind-merge os classifica como cor de texto — e então `text-corpo-tabela`
// e `text-muted-foreground` se anulam mutuamente, sobrevivendo apenas o último. O bug
// é silencioso: a classe some do DOM sem erro nenhum.
const PAPEIS_TIPOGRAFICOS = [
  "text-titulo-pagina",
  "text-titulo-painel",
  "text-cabecalho-tabela",
  "text-corpo-tabela",
  "text-rotulo-kpi",
  "text-numero-kpi",
  "text-numero-heroi",
  "text-legenda",
]

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": PAPEIS_TIPOGRAFICOS,
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
